import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/lib/locale/en';
import fa from 'vuetify/lib/locale/fa';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fa, en },
    current: 'fa',
  },
  rtl: true,
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      default: 'light',
      light: {
        primary: '#237fa1',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#e45959',
        info: '#44bfb3',
        success: '#6cbb47',
        warning: '#e7ac3e',
        danger: '#FD8A8A',
      },
      dark: {
        primary: '#007BFF',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
    icons: {
    iconfont: 'fa', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
  },
});
